@if (componentData.data$ | async; as component) {
  <div
    class="text-component"
    [class.pb-0]="component.removeBottomSpacing | safeCheck"
    [class.pt-0]="component.styleClasses === 'removeTopSpacing' | safeCheck"
  >
    <div class="row">
      <div
        boelsDynamicContentLinkHandler
        [ngClass]="(component.textSmall | safeCheck) ? 'col-lg-8' : 'col-lg-12'"
        [innerHTML]="component.content | prepareHtml"
      ></div>
    </div>
  </div>
}
